import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-notification",
  templateUrl: "./med-icon-notification.component.html",
})
export class MedIconNotificationComponent extends SvgMixinComponent {}
